import { Link } from 'react-router';
import { splitNotificationLinks } from '~/lib/notification-text';

/** A notification body with its in-app settings paths rendered as real links (FRONT-2486). */
export function NotificationBodyText({
  text,
  className,
  onNavigate,
}: {
  text: string;
  className?: string;
  onNavigate?: () => void;
}) {
  return (
    <div className={className}>
      {splitNotificationLinks(text).map((part, i) =>
        typeof part === 'string' ? (
          part
        ) : (
          <Link key={i} to={part.href} onClick={onNavigate} className="underline underline-offset-2 hover:text-foreground">
            {part.label}
          </Link>
        ),
      )}
    </div>
  );
}
